export default {
    en: 'EN',
    fr: 'FR',
    nl: 'NL',
    english: 'Anglais',
    french: 'Français',

    locales: {
        en: {
            name: 'Anglais',
            realName: 'English',
        },
        fr: {
            name: 'Français',
            realName: 'Français',
        },
        nl: {
            name: 'Néerlandais',
            realName: 'Nederlands',
        },
    },
};
